<template>
    <div v-if="src" style="width: 100%;text-align: left">
        <img :src="src" alt="" width="100%">
    </div>
</template>
<script>

    import { defineComponent } from 'vue';
    import QRCode from 'qrcode';


    export default defineComponent({
        name: "PaperQrcode",
        components: {
        },
        props: ['href'],
        data() {
            return {
                loading: true,
                src: ''
            };
        },
        created(){
            this.createQrCode();
        },
        methods: {
            async createQrCode(){
                this.src = await QRCode.toDataURL(this.href);
            },
        }
    });
</script>

<style scoped>

</style>
